(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabUpdateScripts', TabUpdateScripts);

    TabUpdateScripts.$inject = ['$resource'];

    function TabUpdateScripts ($resource) {
        var resourceUrl = 'api/tab-update-scripts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method : 'GET', isArray : true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
